/**
 * Iter-229c — Bookings entry router.
 *
 * Default: serves the new V2 consolidated bookings view.
 * Legacy view is still reachable via ?classic=1 for safe rollback.
 *   /talent/bookings          → V2 (default)
 *   /talent/bookings?classic=1 → legacy
 *   /talent/bookings-v2        → V2 (explicit, unchanged)
 */
import React from 'react';
import { useSearchParams } from 'react-router-dom';
import TalentBookings from './Bookings';        // legacy
import TalentBookingsV2 from './BookingsV2';    // new

const BookingsRouter = () => {
  const [params] = useSearchParams();
  if (params.get('classic') === '1') return <TalentBookings />;
  return <TalentBookingsV2 />;
};

export default BookingsRouter;
